export const withCorrectPrice = (item) => {
    if (!item) {
        return 0
    }
    if (item.newPrice !== undefined) {
        return item.newPrice
    }
    return item.price ?? 0
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const percentDiff = (a, b) => Math.abs(Math.floor(((b - a) / Math.abs(a)) * 100));
